export default class RequestSortType {
    static DATE = 0;
    static DEADLINE = 1;
}
